const API_URL = process.env.REACT_APP_API_URL;

export const ServicesLogin = (values) => {
  return fetch(API_URL+"login", {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(values)
  })
  .then((response) => response.json());  
}